import Collection from "../../../../../core/data-structures/collection";
import MyWorkView from "./my-work-view";
import ArrayUtils from "../../../../../core/gd/utils/array";
import {SortDirection} from "../../../../../core/data-structures/sort";
import {ViewType} from "../../../../../core/gd/const/views/view-type";


export default class MyWorkViewCollection extends Collection<MyWorkView> {

    constructor(models: MyWorkView[]) {
        super(models);
    }

    static initFromJson() {
        const collection = new MyWorkViewCollection([])

        _.map(gd.user.settings.views.myWork.get(gd.companyId).addedViews, (data: JSONObject)=> {
            collection.add(new MyWorkView(data))
        })

        collection.sort()

        return collection
    }

    sort() {
        this.models = _(this.models)
            .orderBy([
                view => !_.isNil(view.sortPosition) ? 0 : 1,
                view => view.sortPosition,
            ], [
                SortDirection.ASC,
                SortDirection.ASC,
            ])
            .map((model, key)=>{
                model.sortPosition = key
                return model
            })
            .value()
    }

    moveLeft(view: MyWorkView) {
        const orderedIds    = _.map(this.models, model=> model.id)
        const oldIndex      = _.indexOf(orderedIds, view.id)
        let newIndex        = oldIndex - 1
        if (newIndex < 0) {
            newIndex = 0
        }

        ArrayUtils.moveInArrayMutate(this.models, oldIndex, newIndex)

        _.map(this.models, (item, key)=> {item.sortPosition = key})

        this.save()
    }

    moveRight(view: MyWorkView) {
        const orderedIds    = _.map(this.models, model=> model.id)
        const oldIndex      = _.indexOf(orderedIds, view.id)
        let newIndex        = oldIndex + 1
        if (newIndex > orderedIds.length - 1) {
            newIndex = orderedIds.length - 1
        }

        ArrayUtils.moveInArrayMutate(this.models, oldIndex, newIndex)

        _.map(this.models, (item, key)=> {item.sortPosition = key})

        this.save()
    }

    moveToStart(view: MyWorkView) {
        const orderedIds    = _.map(this.models, model=> model.id)
        const oldIndex      = _.indexOf(orderedIds, view.id)
        let newIndex        = 0
        if (newIndex < 0) {
            newIndex = 0
        }

        ArrayUtils.moveInArrayMutate(this.models, oldIndex, newIndex)

        _.map(this.models, (item, key)=>{item.sortPosition = key})

        this.save()
    }

    moveToEnd(view: MyWorkView) {
        const orderedIds    = _.map(this.models, model=> model.id)
        const oldIndex      = _.indexOf(orderedIds, view.id)
        let newIndex        = orderedIds.length - 1
        if (newIndex > orderedIds.length - 1) {
            newIndex = orderedIds.length - 1
        }

        ArrayUtils.moveInArrayMutate(this.models, oldIndex, newIndex)

        _.map(this.models, (item, key)=> {item.sortPosition = key})

        this.save()
    }

    generateViewLabel(viewType: ViewType, optionLabel: string) {
        const views = _.filter(this.models, (model)=> {
            return model.type === viewType
        })

        if (views.length === 0) {
            return optionLabel
        } else {
            return optionLabel + " " + (views.length + 1)
        }
    }


    save = async (callback?: callback)=> {

        gd.user.settings.views.myWork.get(gd.companyId).addedViews = this.toJSON()
        gd.user.settings.save(callback)

    }

}
